<template>
	<basic-container>
		<div style="color: red">请输入微信号或者手机号进行搜索并选择！</div>
		<avue-crud
			v-bind="bindVal"
			v-model="formData"
			v-on="onEvent"
			:page.sync="page"
			@on-load="getList"
			@refresh-change="refreshChange"
			@search-reset="searchChange"
			@search-change="searchChange">
			<template slot="menu" slot-scope="{row}">
				<el-button type="text" @click="onCheck(row)">选择</el-button>
			</template>
		</avue-crud>
	</basic-container>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
import {mapGetters} from 'vuex'

const option = {
	//模块名字
	name: 'originChannelIdList',
	optionPath: 'channel/channelOption',
	optionNameList: ['originChannelIdOption'],
	apiPath: 'team/place',
	//接口名字
	apiNameList: ['searchCrmCustomer'],
	//接口名字
	apiNameDelList: [''],
	apiNameAddList: [''],
	apiNameUpdateList: [''],
	//如有时间搜索，则必填，例如['payTime','payTimeStart','payTimeEnd']
	searchData: [],
	//主键
	rowKey: 'id',
}
export default window.$baseCrud(
	{
		data() {
			return {
				page: {
					total: 0,
					currentPage: 1,
					pageSize: 10,
					pageSizes: [10, 20, 40, 80, 100, 500, 1000],
				},
			}
		},
		props: ['channel'],
		computed: {
			...mapGetters(['permissions']),
		},
		created() {},

		methods: {
			//可以重写getList() {},
			//列表前操作方法
			listBefore() {},
			//列表后操作方法
			forMatterListData(data) {
				return data
			},
			//请求错误
			listError() {},
			//请求finally
			listFinally() {},
			//选择数据
			onCheck(row) {
				this.$confirm(`请确认是否选择该客户来源`, '提示', {
					confirmButtonText: '确定',
				}).then(() => {
					this.$emit('chooseChannelId', row)
				})
			},
			//额外添加请求参数
			addRequestData() {
				return {}
			},
		},
	},
	option,
)
</script>

<style lang="scss" scoped></style>
